import { EmployeeForSelectFragment } from 'generated/resources/graphql'
import { z } from 'zod'

export const OwnerFieldSchema = () => {
  return z.object({
    employee: z.custom<EmployeeForSelectFragment>().optional().nullable(),
  })
}
